import { Heading, Text } from "@overmap-ai/blocks"
import { selectIssuesOfProject, selectIssueTypesOfOrganization } from "@overmap-ai/core"
import { memo, useMemo } from "react"

import { useAppSelector, useShallowEqaulSelector } from "../../../store"
import { selectActiveOrganizationId, selectActiveProjectId } from "../../../store/selectors"
import { IssueTypeVisibilityItem } from "../VisibilityItems/IssueTypeVisibilityItem"

export const IssueTypeVisibilityTab = memo(() => {
	const activeOrganizationId = useAppSelector(selectActiveOrganizationId)!
	const activeProjectId = useAppSelector(selectActiveProjectId)!

	const allIssueTypes = useShallowEqaulSelector(selectIssueTypesOfOrganization(activeOrganizationId))
	const issues = useAppSelector(selectIssuesOfProject(activeProjectId))

	// Filter asset types to only show those that have issues
	const issueTypes = useMemo(() => {
		const issueTypeIdsWithIssues = new Set(issues.map((asset) => asset.issue_type))
		return allIssueTypes.filter((assetType) => issueTypeIdsWithIssues.has(assetType.uuid))
	}, [allIssueTypes, issues])

	return (
		<div className="flex w-full flex-col gap-4">
			<section className="flex w-full flex-col gap-2">
				<div className="flex w-full items-center justify-between">
					<Heading>Issues</Heading>
				</div>

				{issueTypes.length > 0 ? (
					<ul className="flex flex-col gap-2">
						{issueTypes.map((issueType) => {
							return <IssueTypeVisibilityItem key={issueType.uuid} issueType={issueType} />
						})}
					</ul>
				) : (
					<div className="flex w-full">
						<Text accentColor="base" weight="regular" size="sm">
							No issues.
						</Text>
					</div>
				)}
			</section>
		</div>
	)
})
IssueTypeVisibilityTab.displayName = "IssueTypeVisibilityTab"
